import React from 'react'
import SearchResultSwitch from './SearchResultSwitch';

export default function SearchResult(props) {
    return (
        <div>
            {props.beforeSearch ?
                <div className="sr-beforesearch">
                    <span>検索すると、ここに結果が一覧表示されます。</span>
                </div>
                :
                props.items && props.items.map(item =>
                <SearchResultSwitch 
                    key={item.id}
                    id={item.id}
                    data={item} 
                    onEnterItem={props.onEnterItem} 
                    onLeaveItem={props.onLeaveItem} 
                    onEnterImg={props.onEnterImg} 
                    onLeaveImg={props.onLeaveImg} 
                    onTagClick={props.onTagClick}
                    activeItem={props.activeItem}
                    items={props.items}
                    map={props.map}/>
                )
            }
            
        </div>
    );
}
